/**
 * Skills -- Grille des competences techniques.
 *
 * Role : presenter les competences groupees par categorie (DevOps, Backend,
 * Cloud, Securite, etc.), avec icones. Aide le recruteur/visiteur a evaluer
 * rapidement le profil technique.
 *
 * Structure : chaque categorie = { title, icon, items[] }. Rendered en grille
 * responsive Tailwind.
 *
 * Donnees : la liste `skills` est hardcodee ici (~une dizaine de categories).
 * Migreront vers l'API en Sprint 004 (endpoint `GET /api/v1/skills`) pour
 * permettre l'ajout de competences depuis le BackOffice sans deploy front.
 *
 * Icones : @heroicons/react outline set. Cf https://heroicons.com/ pour ajouter.
 */

import React from 'react';
import {
  // ServerIcon,
  ServerStackIcon,
  CalendarDateRangeIcon,
  ShieldCheckIcon,
  CloudIcon,
  CodeBracketIcon,
  CpuChipIcon
  // CommandLineIcon
} from '@heroicons/react/24/outline';

const Skills: React.FC = () => {
  const skills = [
    {
      title: "SysOps & DevOps",
      description: "CI/CD, Docker, Kubernetes, Gitlab CI/CD, Jenkins, Linux, Unix, Windows Server",
      icon: <ServerStackIcon className="h-12 w-12" />,
    },
    {
      title: "Cybersecurity",
      description: "Risk Management, SOC, SIEM, Threat Detection, Incident Response, Pentest",
      icon: <ShieldCheckIcon className="h-12 w-12" />,
    },
    {
      title: "Cloud",
      description: "OVH, AWS, GCP, Infrastructure as Code",
      icon: <CloudIcon className="h-12 w-12" />,
    },
    {
      title: "Développement",
      description: "Python, Odoo, Django, JavaScript, TypeScript",
      icon: <CodeBracketIcon className="h-12 w-12" />,
    },
    {
      title: "Automatisation",
      description: "Ansible, Terraform, Puppet, Chef",
      icon: <CpuChipIcon className="h-12 w-12" />,
    },
    {
      title: "Project Management",
      description: "Waterfall, Agile, PMPBOK, Jira, MS PROJECT",
      icon: <CalendarDateRangeIcon className="h-12 w-12" />,
    }
  ];

  return (
    <section id="skills" className="py-20 bg-base-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center mb-12">Compétences</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="card-body items-center text-center">
                <div className="text-primary mb-4">
                  {skill.icon}
                </div>
                <h3 className="card-title text-xl mb-2">{skill.title}</h3>
                <p className="opacity-75">{skill.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
